/*
 * @Author: caoshuai 63615488@qq.com
 * @Date: 2022-10-24 17:02:34
 * @LastEditors: caoshuai 63615488@qq.com
 * @LastEditTime: 2022-11-18 11:59:16
 * @FilePath: /pcsd-bp-live-portal/packages/www/plugins/static.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import * as Mamba from '@mamba/clients';
import lodash from 'lodash';
const baseURL = process.env.base || ''; //bad
/**
 * @desc 静态资源
 */
export const Static = {
    choujiangjilu: 'images/choujiangjilu.png',
    down: 'images/down.png',
    edit: 'images/edit.png',
    erweima: 'images/erweima.png',
    gouwuche: 'images/gouwuche.png',
    heart: 'images/heart.png',
    jieguo: 'images/jieguo.png',
    lianjie: 'images/lianjie.png',
    pengyouquan: 'images/pengyouquan.png',
    touxiang: 'images/touxiang.png',
    video: 'images/video.png',
    weibo: 'images/weibo.png',
    weixin: 'images/weixin.png',
    zhongjiang: 'images/zhongjiang.png',
    zhuanpan: 'images/zhuanpan.png',
    logo: 'images/logo.png',
    biaoqing: 'images/biaoqing.png',
    loading: 'images/loading.gif',
    success: 'images/success.png',
    ppt: 'images/ppt.png',
    weizhongjiang: 'images/weizhongjiang.png',
    yizhongjiang: 'images/yizhongjiang.png',
    qq: 'images/qq.png',
    aojiao: 'images/aojiao.png',
    dakao: 'images/dakao.png',
};
lodash.merge(Static, lodash.mapValues(Static, (val) => {
    if (Mamba.Regulars.url.test(val) ||
        ['base64', '/static/'].some((x) => lodash.includes(val, x))) {
        return val;
    }
    return lodash.join([lodash.trimEnd(baseURL, '/'), lodash.trimStart(val, '/')], '/');
}));
